import { Col, Form, Row } from "antd";
import React from "react";
import CheckBox from "../../../../components/atoms/Checkbox";
import RadioGroup from "../../../../components/atoms/RadioGroup";
import Table from "../../../../components/atoms/Table";
import ExplainWrapper from "../../../../components/molecures/ExplainWrapper";
import { RepairShopDayOffs } from "../../../../model/RepairShopDayOffs";
import sharedConstants from "../../../../shared/constants";
import { DayOffDay, DayOffWeek, RoutineType } from "../../../../shared/enums";
import {
  daysArray,
  hasRoutineRestArray,
  routineTypeArray,
} from "../../../../shared/options";
import { getNotWeeklyDayOffsColumns } from "../../constants";
import { NotWeeklyDayOff, RenderInputProps } from "../../Interface";
import { CustomTd } from "../../styles";
import PlusButtonRow from "../PlusButtonRow";

const { Item, useWatch } = Form;
const DayOffInputs: React.FC<RenderInputProps> = (props) => {
  const { form } = props;
  const hasRoutineRestday = useWatch("hasRoutineRestDay", form);
  const routineType = useWatch("routineDayOffType", form);
  const weeklyDayOffs: RepairShopDayOffs[] = useWatch("weeklyDayOffs", form);
  const notWeeklyDayOffs: NotWeeklyDayOff[] = useWatch(
    "notWeeklyDayOffs",
    form
  );

  return (
    <Row gutter={[0, 12]}>
      <Col span={24}>
        <Item noStyle name="hasRoutineRestDay">
          <RadioGroup options={hasRoutineRestArray} />
        </Item>
      </Col>
      <Col span={24}>
        <Item noStyle name="routineDayOffType">
          <RadioGroup
            disabled={!hasRoutineRestday}
            options={routineTypeArray}
          />
        </Item>
      </Col>
      <Col span={24}>
        <Item
          name="weeklyDayOffs"
          noStyle
          rules={[
            {
              validator: async () => {
                if (routineType === RoutineType.EVERY_WEEK) {
                  if (weeklyDayOffs?.length === 0)
                    return Promise.reject(
                      new Error(
                        sharedConstants.message.ALERT_MESSAGE.NULL_REQUIRED
                      )
                    );
                }
                return Promise.resolve();
              },
            },
          ]}
        />
        <Item name="notWeeklyDayOffs" noStyle />
        {!hasRoutineRestday ? null : routineType === RoutineType.EVERY_WEEK ? (
          <ExplainWrapper
            status={{
              status:
                form.getFieldError("weeklyDayOffs")?.length > 0
                  ? "error"
                  : undefined,
              explain: form.getFieldError("weeklyDayOffs")[0],
            }}
          >
            <CheckBox
              options={daysArray}
              onChange={(e) => {
                const newDayOffs = e.map((val: DayOffDay) => ({
                  dayOffWeek: DayOffWeek.EVERY_WEEK,
                  dayOffDay: val,
                }));
                form.setFieldsValue({ weeklyDayOffs: newDayOffs });
              }}
              value={weeklyDayOffs?.map((val) => val.dayOffDay)}
            />
          </ExplainWrapper>
        ) : (
          <>
            <Table
              pagination={false}
              columns={getNotWeeklyDayOffsColumns(form, notWeeklyDayOffs)}
              size="large"
              components={{
                body: {
                  cell: ({ children }: any) => (
                    <CustomTd verticalAlign="middle">{children}</CustomTd>
                  ),
                },
              }}
              rowKey="dayOffWeek"
              dataSource={notWeeklyDayOffs}
            />
            <PlusButtonRow
              disabled={notWeeklyDayOffs?.length >= 5}
              onClick={() => {
                form.setFieldsValue({
                  notWeeklyDayOffs: [
                    ...notWeeklyDayOffs,
                    {
                      dayOffWeek: undefined,
                      dayOffDays: [
                        // 공휴일 기본설정 제거
                        // DayOffDay.MONDAY,
                        // DayOffDay.TUESDAY,
                        // DayOffDay.WEDNESDAY,
                        // DayOffDay.THURSDAY,
                        // DayOffDay.FRIDAY,
                      ],
                    },
                  ],
                });
              }}
            />
          </>
        )}
      </Col>
    </Row>
  );
};
export default DayOffInputs;
